import { css as f, LitElement as g, html as l, nothing as m } from "lit";
import { property as c, customElement as h } from "lit/decorators.js";
import { classMap as v } from "lit/directives/class-map.js";
import { b } from "./styles-scZ6dVz-.js";
var y = Object.defineProperty, x = Object.getOwnPropertyDescriptor, u = (e, t, o, i) => {
  for (var r = i > 1 ? void 0 : i ? x(t, o) : t, n = e.length - 1, a; n >= 0; n--)
    (a = e[n]) && (r = (i ? a(t, o, r) : a(r)) || r);
  return i && r && y(t, o, r), r;
};
let d = class extends g {
  constructor() {
    super(...arguments), this.orientation = "vertical", this.alternate = !1;
  }
  render() {
    const e = {
      timeline: !0,
      [this.orientation]: !0,
      alternate: this.alternate
    };
    return l`
      <div part="timeline" class=${v(e)}>
        <slot></slot>
      </div>
    `;
  }
};
d.styles = [
  b,
  f`
      :host {
        display: block;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .timeline {
        --timeline-line-color: var(--r5-timeline-line-color, var(--r5-border));
        --timeline-line-width: var(--r5-timeline-line-width, 2px);

        display: flex;
        position: relative;
      }

      .vertical {
        flex-direction: column;
      }

      .horizontal {
        flex-direction: row;
        overflow-x: auto;
      }

      /* Alternate mode */
      .alternate {
        --timeline-alternate: 1;
      }

      ::slotted(ark-timeline-item) {
        flex-shrink: 0;
      }
    `
];
u([
  c({ type: String, reflect: !0 })
], d.prototype, "orientation", 2);
u([
  c({ type: Boolean, reflect: !0 })
], d.prototype, "alternate", 2);
d = u([
  h("ark-timeline")
], d);
var w = Object.defineProperty, z = Object.getOwnPropertyDescriptor, p = (e, t, o, i) => {
  for (var r = i > 1 ? void 0 : i ? z(t, o) : t, n = e.length - 1, a; n >= 0; n--)
    (a = e[n]) && (r = (i ? a(t, o, r) : a(r)) || r);
  return i && r && w(t, o, r), r;
};
let s = class extends g {
  constructor() {
    super(...arguments), this.status = "pending";
  }
  render() {
    const e = {
      item: !0,
      [this.status]: !0
    }, t = this.querySelector('[slot="icon"]') !== null, o = {
      dot: !0,
      "has-icon": t
    };
    return l`
      <div part="item" class=${v(e)}>
        <div class="dot-container">
          <div part="dot" class=${v(o)}>
            ${t ? l`<span class="icon-slot"><slot name="icon"></slot></span>` : l`<span class="dot-inner"></span>`}
          </div>
          <div part="connector" class="connector"></div>
        </div>

        <div part="content" class="content">
          ${this.itemTitle ? l`<h4 class="title">${this.itemTitle}</h4>` : m}
          ${this.description ? l`<p class="description">${this.description}</p>` : m}
          <slot></slot>
          ${this.time ? l`<div class="time">${this.time}</div>` : m}
        </div>
      </div>
    `;
  }
};
s.styles = [
  b,
  f`
      :host {
        display: block;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .item {
        --dot-size: var(--r5-timeline-dot-size, 12px);
        --dot-ring-size: calc(var(--dot-size) + 8px);
        --line-color: var(--r5-timeline-line-color, var(--r5-border));
        --line-width: var(--r5-timeline-line-width, 2px);

        display: flex;
        position: relative;
        padding-bottom: var(--r5-space-6);
      }

      .item:last-child {
        padding-bottom: 0;
      }

      /* Dot container */
      .dot-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        width: var(--dot-ring-size);
        margin-right: var(--r5-space-4);
      }

      /* Dot */
      .dot {
        display: flex;
        align-items: center;
        justify-content: center;
        width: var(--dot-ring-size);
        height: var(--dot-ring-size);
        border-radius: var(--r5-radius-full);
        background-color: var(--r5-bg);
        border: var(--line-width) solid var(--line-color);
        z-index: 1;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .dot-inner {
        width: var(--dot-size);
        height: var(--dot-size);
        border-radius: var(--r5-radius-full);
        background-color: var(--r5-timeline-dot-bg, var(--r5-border));
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      /* Status colors */
      .completed .dot {
        border-color: var(--r5-color-success-500);
        background-color: var(--r5-color-success-50);
      }

      .completed .dot-inner {
        background-color: var(--r5-color-success-500);
      }

      .current .dot {
        border-color: var(--r5-color-primary-500);
        background-color: var(--r5-color-primary-50);
      }

      .current .dot-inner {
        background-color: var(--r5-color-primary-500);
        animation: pulse 2s infinite;
      }

      .pending .dot {
        border-color: var(--r5-border);
        background-color: var(--r5-bg-muted);
      }

      .pending .dot-inner {
        background-color: var(--r5-text-muted);
        opacity: 0.5;
      }

      .error .dot {
        border-color: var(--r5-color-danger-500);
        background-color: var(--r5-color-danger-50);
      }

      .error .dot-inner {
        background-color: var(--r5-color-danger-500);
      }

      /* Connector line */
      .connector {
        flex: 1;
        width: var(--line-width);
        background-color: var(--line-color);
        margin-top: var(--r5-space-1);
      }

      .item:last-child .connector {
        display: none;
      }

      .completed .connector {
        background-color: var(--r5-color-success-500);
      }

      /* Content */
      .content {
        flex: 1;
        min-width: 0;
        padding-top: var(--r5-space-0-5);
      }

      .title {
        font-family: var(--r5-font-body);
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
        margin: 0 0 var(--r5-space-1) 0;
      }

      .description {
        font-family: var(--r5-font-body);
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        margin: 0;
      }

      .time {
        font-family: var(--r5-font-body);
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        margin-top: var(--r5-space-1);
      }

      /* Custom icon slot */
      .dot.has-icon .dot-inner {
        display: none;
      }

      .icon-slot {
        display: flex;
        align-items: center;
        justify-content: center;
        color: inherit;
      }

      .icon-slot ::slotted(*) {
        width: 0.875rem;
        height: 0.875rem;
      }

      .completed .icon-slot {
        color: var(--r5-color-success-600);
      }

      .current .icon-slot {
        color: var(--r5-color-primary-600);
      }

      .error .icon-slot {
        color: var(--r5-color-danger-600);
      }

      /* Pulse animation */
      @keyframes pulse {
        0%, 100% {
          opacity: 1;
          transform: scale(1);
        }
        50% {
          opacity: 0.7;
          transform: scale(0.9);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .current .dot-inner {
          animation: none;
        }
      }
    `
];
p([
  c({ type: String, reflect: !0 })
], s.prototype, "status", 2);
p([
  c({ type: String, attribute: "title" })
], s.prototype, "itemTitle", 2);
p([
  c({ type: String })
], s.prototype, "description", 2);
p([
  c({ type: String })
], s.prototype, "time", 2);
s = p([
  h("ark-timeline-item")
], s);
export {
  d as A,
  s as a
};
//# sourceMappingURL=ark-timeline-item-BonH_MPD.js.map
